import Refresh from '@mui/icons-material/Refresh';
import { Box, Button } from '@mui/material';

export function GeneralError({ error, resetErrorBoundary }: { error: any; resetErrorBoundary: (error: any) => void }) {
    const handleRefresh = () => resetErrorBoundary(error);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ marginTop: '60px', padding: '18px 24px 38px', textAlign: 'center' }}>
                <Box sx={{ fontSize: '28px', marginBottom: '10px' }}>
                    <span role="img" aria-label="hushed face">
                        😯
                    </span>
                </Box>
                <Box
                    sx={{
                        fontSize: '19px',
                        fontWeight: 500,
                        lineHeight: '17px',
                        marginBottom: '24px',
                        color: '#3A4B59',
                    }}
                >
                    Something went wrong
                </Box>
                <Box sx={{ fontSize: '15px', lineHeight: '18px', color: '#3A4B59' }}>
                    We&apos;re working on fixing the problem <br /> Please retry again soon
                </Box>
                <Button
                    onClick={handleRefresh}
                    variant="contained"
                    startIcon={<Refresh />}
                    disableElevation
                    sx={{
                        width: '249px',
                        height: '42px',
                        marginTop: '30px',
                        borderRadius: '21px',
                        backgroundColor: '#5F8EFA',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#7795d9',
                        },
                    }}
                >
                    Refresh page
                </Button>
            </Box>
        </Box>
    );
}

export default GeneralError;
